"use client";
import React, { useState } from "react";
import styled from "@emotion/styled";
import { useDictionary } from "../context/dictionaryProvider";
import {
  ContactForm,
  ContactWrapShape,
  SecondaryOuter,
  SendBtn,
} from "./molecules";
import InputTextField from "./atoms/InputTextField";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { staticFormsActions } from "../actions/staticForms";
import Loading from "../app/[lang]/loading";

const newsLetterScema = yup
  .object({
    email: yup
      .string()
      .email()
      .required()
      .matches(
        /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
        "Email must have a valid domain"
      ),
  })
  .required();

const NewsletterForm = ({ varrient = false, btnStyle, btnText }) => {
  const dict = useDictionary();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(newsLetterScema),
  });

  const [response, setResponse] = useState("");

  const onSubmit = async (data) => {
    const res = await staticFormsActions("newsLetterForm", data);
    if (res?.status) setResponse("you have been subscibed for newsletter");
    reset();
    webengage.track('Subscribe', {
      category: 'Subscribe',
      label: 'Newsletter',
      value: 1,
      userEmail: data.email, 
    });
    webengage.user.setAttribute("we_email", data.email);
    const userId = webengage.state.getForever().luid
    webengage.user.login(data.email);
    setTimeout(() => {
      setResponse("");
    }, 6000);
  };

  return (
    <>
      {!varrient ? (
        <Stack
          width="1fr"
          onSubmit={handleSubmit(onSubmit)}
          className="mt-10 lg:mt-16 items-center"
          flow="row"
        >
          <p className="mb-3 w-full relative text-white font-semibold text-lg letter-[0.54px]">
            {dict?.footer.subscribeTxt}
          </p>
          <div className="grid grid-flow-col grid-cols-[repeat(1,1fr)] gap-7 items-center">
            <InputTextField
              type={"email"}
              {...register("email", { required: true })}
              placeholder={dict?.form?.placeholders?.email}
              aria-invalid={errors.email ? "true" : "false"}
            />
            <SecondaryOuter
              borderColor="#fff"
              color="#fff"
              size="14px"
              padding="10px 16px"
              borderWidth="1.6px solid"
              type="submit"
            >
              {dict?.footer.subscribe}
            </SecondaryOuter>
          </div>
          <span className="text-green-400">{response && response}</span>
        </Stack>
      ) : (
        <>
          <ContactForm className="relative">
            {/* {showformShape && (
              <div className="absolute z-20 -top-20 -right-28">
                <ContactFormShape />
              </div>
            )} */}
            {!isSubmitting ? (
              <form
                className="relative bg-[#fff]"
                onSubmit={handleSubmit(onSubmit)}
              >
                <div
                  className="space-y-12 px-12 pb-10 pt-12"
                  style={{ border: "1px solid", borderRadius: "16px" }}
                >
                  <div className="pb-6">
                    <p className="font-extrabold text-lg tracking-[0.54px] mb-2">
                      {dict?.newsLetter?.title}
                    </p>
                    <p className="text-sm leading-[23.8px mb-6">
                      {dict?.newsLetter?.description}
                    </p>
                    {/* {title && <SubTitle className="my-10">{title}</SubTitle>} */}

                    <div className="sm:col-span-1 mb-8">
                      <div className="mt-2">
                        <InputTextField
                          label={dict?.form?.fieldNames.email}
                          type={"email"}
                          isInvalid={!!errors?.email}
                          errorMessage={errors?.email?.message}
                          {...register("email", { required: true })}
                          aria-invalid={errors.email ? "true" : "false"}
                        />
                        <h3 className="font-semibold text-sm text-[#008b3d] !m-0">
                          {response && response}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
                <SendBtn type="submit" disabled={isSubmitting} style={btnStyle} >
                  {btnText || dict?.send}
                </SendBtn>
                <ContactWrapShape />
              </form>
            ) : (
              <Loading />
            )}
          </ContactForm>
        </>
      )}
    </>
  );
};

const Stack = styled.form`
  display: grid;
  grid-auto-flow: ${(props) => (props.flow ? props.flow : "column")};
  grid-template-columns: ${(props) =>
    props.width ? props.width : "25% 1fr 1fr 1fr"};
  gap: ${(props) => (props.gap ? props.gap : "")};
`;

export default NewsletterForm;
